import { useAuth0 } from '#~/auth/index.js';
import { StudioError } from '#~/error/index.js';
import { logger } from '#~/logger/index.js';
import { proxy } from './nats.js';
import type { Props } from './types.js';
import { Loader } from '@studio/design-system/loader';
import { useAsyncEffect, useUnmount } from '@studio/react-utils/hooks';
import { useState } from 'react';
import type { ReactElement } from 'react';

/** Manages the connection to NATS. */
export const Provider = ({ children }: Props): ReactElement => {
  const { getAccessTokenSilently } = useAuth0();
  const [error, setError] = useState<Error>();
  const [isReady, setReady] = useState(false);

  useAsyncEffect(
    function* generator(signal: AbortSignal) {
      try {
        //yield proxy.connectNats(yield* unwrap(getAccessTokenSilently()));

        setReady(true);
      } catch (error_) {
        if (!signal.aborted) {
          setError(error_ as Error);
        }
      }
    },
    [getAccessTokenSilently]
  );

  if (error) {
    console.error(error);
    throw new StudioError('Unable to connect to NATS.', { cause: error });
  }

  // Close the connection on unmount.
  useUnmount(() => {
    proxy.clearListeners();

    proxy.disconnect().catch((error_) => {
      logger.critical(error_);
    });
  });

  return !isReady ? <Loader /> : <>{children}</>;
};
